import { useQuery } from '@tanstack/react-query';
import { useApiAppLegacy } from '@/shared/api';
import { userProfileQueryOptions } from './user-profile.query-options';

/**
 * 사용자 프로필 query — `userProfileQueryOptions` (entity SSOT) 를 React 컨텍스트에 적용.
 * BE nested → FE flat 변환은 options 안 queryFn 이 담당.
 */
export function useUserProfileQuery() {
  const api = useApiAppLegacy();
  return useQuery(userProfileQueryOptions(api));
}
